<div
  *ngIf="cta?.targetUrl"
  tabindex="0"
  [className]="cta?.rowClass"
  (agInteract)="targetLink(cta.targetUrl)"
>
  <div
    class="link-one cursor-pointer"
    alt=""
    [ngStyle]="getCTAstyles()"
    [title]="cta?.imgTitle && cta?.imgTitle !== '' ? cta?.imgTitle : ''"
    [tabindex]="cta.imgUrl ? 0 : -1"
  >
    <div class="border-line">
      <h3 *ngIf="cta.title" [ngStyle]="{ background: cta.titleBack ? cta.titleBack : titleBack }">
        {{ cta?.title }}
      </h3>
      <p *ngIf="cta.paragraph" [ngStyle]="{ background: cta.paraBack ? cta.paraBack : paraBack }">
        {{ cta?.paragraph }}
      </p>
      <button
        *ngIf="cta.btnShow"
        role="button"
        type="button"
        tabindex="0"
        [attr.aria-label]="cta.btnLabel"
        [ngClass]="cta.btnClass ? cta.btnClass : 'btn btn-primary'"
        (focus)="onBtnFocus($event)"
        (focusout)="onBtnFocusOut($event)"
      >
        {{ cta.btnLabel }}
      </button>
    </div>
  </div>
</div>
<!-- IF NO ANCHOR LINK -->
<div *ngIf="!cta.targetUrl" [className]="cta.rowClass">
  <div
    class="link-one"
    alt=""
    [ngStyle]="getCTAstyles()"
    [title]="cta?.imgTitle && cta?.imgTitle !== '' ? cta?.imgTitle : ''"
  >
    <div class="border-line">
      <h3 *ngIf="cta.title" [ngStyle]="{ background: cta.titleBack ? cta.titleBack : titleBack }">
        {{ cta?.title }}
      </h3>
      <p *ngIf="cta.paragraph" [ngStyle]="{ background: cta.paraBack ? cta.paraBack : paraBack }">
        {{ cta?.paragraph }}
      </p>
      <button
        *ngIf="cta.btnShow"
        role="button"
        type="button"
        [attr.aria-label]="cta.btnLabel"
        [ngClass]="cta.btnClass ? cta.btnClass : btnClass"
        (focus)="onBtnFocus($event)"
        (focusout)="onBtnFocusOut($event)"
      >
        {{ cta.btnLabel }}
      </button>
    </div>
  </div>
</div>
